import { Injectable } from "@nestjs/common";
import { Defect } from "../defect.entity";
import { DefectDto } from "./defect.dto";

@Injectable()
export class DefectAdapter {
    public conevertDtoToEntity(dto: DefectDto, isUpdate: boolean = false): Defect {
        const entityObj = new Defect();
        entityObj.defectId = dto.defectId;
        entityObj.defectName = dto.defectName;
        entityObj.isActive = dto.isActive == undefined ? true : dto.isActive;
        if (isUpdate) {
            entityObj.updatedUser = dto.updatedUser;
        } else {
            entityObj.isActive = true;
            entityObj.createdUser = dto.createdUser;
        }
        return entityObj
    }

    public convertEntityToDto(entityObj: Defect): DefectDto {
        const dto = new DefectDto;
        dto.defectId = entityObj.defectId;
        dto.defectName = entityObj.defectName;
        dto.isActive = entityObj.isActive;
        dto.createdAt = entityObj.createdAt;
        dto.updatedAt = entityObj.updatedAt;
        dto.createdUser = entityObj.createdUser;
        dto.updatedUser = entityObj.updatedUser;
        dto.versionFlag = entityObj.versionFlag;
        return dto;
    }
}